<template>
  <div class="el-dropdown" v-clickoutside="hide">
    <el-button-group>
      <slot name="default"></slot>
      <el-button
        ref="trigger"
        :size="$attrs.size"
        class="el-dropdown__caret-button"
      >
        <i class="el-dropdown__icon el-icon-arrow-down"></i>
      </el-button>
    </el-button-group>
    <slot name="dropdown"> </slot>
  </div>
</template>
<script>
import Clickoutside from "element-ui/src/utils/clickoutside";

export default {
  name: "dropdown_button_group",
  directives: { Clickoutside },
  methods: {
    hide() {}
  }
};
</script>

<style scoped></style>
